//components/payments/PaymentComponents.jsx
import React, { useState } from 'react';
import './PaymentComponent.css';
import paymentGatewayOptions from './PaymentGateway.json';
import paymentModeOptions from './PaymentMode.json';
import PaymentInitiated from './PaymentInitiated';

const PaymentComponent = ({ onClose, loggedInUserName, itemPrice, itemID, itemName, itemDetails  }) => {
    const [customerName, setCustomerName] = useState(loggedInUserName);
    const [customerAddress, setCustomerAddress] = useState('');
    // const [itemID, setItemID] = useState(itemID);
    // const [itemName, setItemName] = useState(itemName);
    // const [itemDetails, setItemDetails] = useState(itemDetails);
    // const [itemPrice, setItemPrice] = useState(itemPrice);
    const [selectedPaymentGateway, setSelectedPaymentGateway] = useState('');
    const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
    const [addressError, setAddressError] = useState('');
    const [gatewayError, setGatewayError] = useState('');
    const [modeError, setModeError] = useState('');

    const [showPaymentInitiated, setShowPaymentInitiated] = useState(false);


    const handlePayNow = () => {
        let hasError = false;
        if (!customerAddress.trim()) {
            setAddressError('Customer Address cannot be blank');
            hasError = true;
        } else {
            setAddressError('');
        }
        if (!selectedPaymentGateway) {
            setGatewayError('Please select Payment Gateway');
            hasError = true;
        } else {
            setGatewayError('');
        }
        if (!selectedPaymentMode) {
            setModeError('Please select Payment Mode');
            hasError = true;
        } else {
            setModeError('');
        }
        if (hasError) {
            return;
        }
        setShowPaymentInitiated(true);
        // onclose();
    };
    
    if (showPaymentInitiated) {
        return (
            <PaymentInitiated
                paymentDetails={{
                    customerName,
                    customerAddress,
                    itemID: itemID,
                    itemName: itemName,
                    itemDetails: itemDetails,
                    itemPrice: itemPrice,
                    paymentGateway: selectedPaymentGateway,
                    paymentMode: selectedPaymentMode,
                }}
            />
        );
    }

    return (
        <div className="payment-form">
            <h2>Payment Details</h2>
            <label htmlFor="customerName">Customer Name:</label>
            <input type="text" id="customerName" value={customerName} onChange={e => setCustomerName(e.target.value)} />
            <label htmlFor="customerAddress">Customer Address:</label>
            <input type="text" id="customerAddress" value={customerAddress} onChange={e => setCustomerAddress(e.target.value)} />
            {addressError && <span className="error">{addressError}</span>}
            <label htmlFor="itemID">Item ID:</label>
            <input type="text" id="itemID" value={defaultItemID} readOnly className="small-input" />
            <label htmlFor="itemName">Item Name:</label>
            <input type="text" id="itemName" value={defaultItemName} readOnly />
            <label htmlFor="itemDetails">Item Details:</label>
            <input type="text" id="itemDetails" value={defaultItemDetails} readOnly />
            <label htmlFor="itemPrice">Price:</label>
            <input type="text" id="itemPrice" value={itemPrice} readOnly />
            <label htmlFor="paymentGateway">Payment Gateway:</label>
            <select className="select" id="paymentGateway" value={selectedPaymentGateway} onChange={e => setSelectedPaymentGateway(e.target.value)}>
                <option value="">Select Payment Gateway</option>
                {paymentGatewayOptions.map(option => (
                    <option key={option.id} value={option.name}>{option.name}</option>
                ))}
            </select>
            {gatewayError && <span className="error">{gatewayError}</span>}
            <label htmlFor="paymentMode">Payment Mode:</label>
            <select id="paymentMode" value={selectedPaymentMode} onChange={e => setSelectedPaymentMode(e.target.value)}>
                <option value="">Select Payment Mode</option>
                {paymentModeOptions.map(option => (
                    <option key={option.id} value={option.name}>{option.name}</option>
                ))}
            </select>
            {modeError && <span className="error">{modeError}</span>}
            <div className="buttons">
                <button onClick={onClose}>Cancel</button>
                <button onClick={handlePayNow}>Pay Now</button>
            </div>
        </div>
    );
};

export default PaymentComponent;
